import React from 'react';
import styled from 'styled-components';
import { useLink } from '@react-aria/link';

import { colorTokens } from '../../../../../tokens/globals/tokens';
import { SiteKitIcon } from '../SiteKitIcon';

import { buttonTokens } from '../../../../../tokens/components/Button/tokens';

// Fragments
const IconAnchorWrapper = styled.a`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: transparent;
  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }

  &:focus {
    box-shadow: ${buttonTokens.ShadowSecondaryKeyboardFocus};
  }
`;

const SiteKitIconWrapper = styled.i`
  display: inline-flex;
  place-items: center;
  color: ${colorTokens.GlobalBrandBlack};
`;

// Exports
interface SiteKitIconAnchorProps extends React.AnchorHTMLAttributes<Element> {
  icon: string;
  label: string;
  theme?: 'light' | 'light-secondary';
}
const SiteKitIconAnchor = (props: SiteKitIconAnchorProps) => {
  const { label, theme, icon, ...otherProps } = props;

  // This is a false positive, evaluated by Rodrigo
  // eslint-disable-next-line ssr-friendly/no-dom-globals-in-react-fc
  const ref = React.useRef() as React.MutableRefObject<HTMLAnchorElement | null>;
  const { linkProps } = useLink(props, ref);

  return (
    <IconAnchorWrapper {...linkProps} {...otherProps} aria-label={label}>
      <SiteKitIconWrapper>
        <SiteKitIcon theme={theme} icon={icon} />
      </SiteKitIconWrapper>
    </IconAnchorWrapper>
  );
};

SiteKitIconAnchor.displayName = 'SiteKit.IconAnchor';

export { SiteKitIconAnchor, SiteKitIconAnchorProps };
